/* PDP wholesale / accordion / details */
(function () {
  function bindWholesale() {
    document.querySelectorAll('.pdp-wholesale').forEach(function (el) {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';
      var btn = el.querySelector('.pdp-wholesale__header');
      var toggle = el.querySelector('.pdp-wholesale__toggle');
      if (!btn || !toggle) return;
      btn.addEventListener('click', function () {
        var open = el.getAttribute('data-open') !== 'false';
        el.setAttribute('data-open', open ? 'false' : 'true');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        toggle.textContent = open ? '+' : '−';
      });
    });
  }

  function bindAccordion() {
    document.querySelectorAll('.pdp-accordion').forEach(function (accordion) {
      if (accordion.dataset.bound) return;
      accordion.dataset.bound = '1';
      accordion.querySelectorAll('.pdp-accordion-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.pdp-item');
          var content = item && item.querySelector('.pdp-content');
          var arrow = btn.querySelector('.pdp-arrow');
          if (!content || !arrow) return;
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          accordion.querySelectorAll('.pdp-accordion-btn').forEach(function (otherBtn) {
            otherBtn.setAttribute('aria-expanded', 'false');
            var a = otherBtn.querySelector('.pdp-arrow');
            if (a) a.textContent = '+';
          });
          accordion.querySelectorAll('.pdp-content').forEach(function (c) {
            c.style.maxHeight = null;
            c.classList.remove('is-open');
          });
          if (!isOpen) {
            btn.setAttribute('aria-expanded', 'true');
            content.classList.add('is-open');
            content.style.maxHeight = content.scrollHeight + 'px';
            arrow.textContent = '−';
          }
        });
      });
    });
  }

  function bindDetails() {
    document.querySelectorAll('.pdp-details').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      root.querySelectorAll('.pdp-details__header').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.pdp-details__item');
          if (!item) return;
          var open = item.getAttribute('data-open') !== 'false';
          item.setAttribute('data-open', open ? 'false' : 'true');
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          var toggle = btn.querySelector('.pdp-details__toggle');
          if (toggle) toggle.textContent = open ? '+' : '−';
        });
      });
    });
  }

  function bindAll() {
    bindWholesale();
    bindAccordion();
    bindDetails();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
  document.addEventListener('shopify:section:load', bindAll);
})();
